import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

import * as dsm from "../../../utils/dsm"
import * as mixins from "../../../utils/mixins"

import SidewaysTree from "../../svgs/TreeSideways"

export function HeaderNavBar({ children }) {
  return (
    <div
      css={css`
        background: white;
        padding: 0;
      `}
    >
      {children}
    </div>
  )
}

export function HeaderNavBarBackLink({ children, to }) {
  return (
    <Link
      css={css`
        display: flex;
        align-items: center;
        text-decoration: none;
        padding: 0.5rem 0.85rem;

        ${mixins.device.mobileL} {
          padding: 0.5rem 1.15rem;
        }

        ${mixins.device.mobileX} {
          padding: 0.5rem 1.25rem;
        }
      `}
      to={to}
    >
      <BackArrowTree />
      <h3
        css={css`
          margin: 0;
          ${dsm.fonts.display};
          color: ${dsm.colors.brand.logoGreen.dark};
          text-decoration: underline;
          font-weight: bolder;
          padding-top: 0.05rem;
          font-size: 0.75rem;

          ${mixins.device.mobileX} {
            font-size: 0.85rem;
          }
        `}
      >
        {children}
      </h3>
    </Link>
  )
}

export function BackArrowTree() {
  return (
    <div
      css={css`
        transform: rotate(180deg);
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.4rem;
        display: flex;
        align-items: center;
      `}
    >
      <SidewaysTree
        styles={css`
          height: 100%;
        `}
      />
    </div>
  )
}

export function HeaderNavBarContainer({ children }) {
  return (
    <div
      css={css`
        background: white;
        padding: 0 0.75rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      `}
    >
      {children}
    </div>
  )
}

export function ForwardArrowTree() {
  return (
    <div
      css={css`
        width: 0.8rem;
        height: 0.8rem;
        margin: 0 1rem 0.1rem 1rem;
        display: flex;
        align-items: center;
      `}
    >
      <SidewaysTree
        styles={css`
          height: 100%;
        `}
      />
    </div>
  )
}

export function NavLinkItem({ children, to }) {
  return (
    <Link
      to={to}
      css={css`
        margin: 0;
        ${dsm.fonts.display};
        color: ${dsm.colors.brand.logoGreen.dark};
        transition: color 0.3rem ease-in-out;
        text-decoration: underline;
        font-weight: bolder;
        padding-top: 0.05rem;
        font-size: 0.75rem;

        &:hover {
          color: ${dsm.colors.brand.logoGreen.med};
          transition: color 0.3rem ease-in-out;
        }
        ${mixins.device.mobileX} {
          font-size: 0.85rem;
        }
      `}
    >
      {children}
    </Link>
  )
}
